module.exports = __webpack_public_path__ + "static/media/CTLA_6-475w.17954914.webp";